module.exports = __webpack_public_path__ + "assets/landscape-default.e097ee48.svg";